import React from 'react'
import GroceriesItem from './item.js'
import styles from './index.module.scss'

function Groceries ({list}) {
    return (
        <ul className={`groceries ${styles.groceries}`}>
            <GroceriesItem list={list}></GroceriesItem>
        </ul>
    )
}

export default Groceries;